import React, { useState } from 'react';
import PropTypes from 'prop-types';
import '../../../css/svg.css';

const FloridaMap = ({ onZoneClick }) => {
	const [selectedZone, setSelectedZone] = useState(null);

	const handleZoneClick = (zoneId) => {
		setSelectedZone(zoneId);
		if (onZoneClick) {
			onZoneClick(zoneId);
		}
		console.log('Zone Clicked: %s', zoneId);
	};

	return (
		<svg
			id='florida'
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 1000 1000'
			className='map'>
			<polygon
				id='FL_ZS'
				points='811.95 389.27 821.83 415.39 836.65 443.62 863.47 482.43 885.35 519.13 903.7 547.36 918.52 573.47 929.1 605.23 929.81 629.22 932.63 655.34 934.75 682.16 931.22 701.92 923.46 717.44 921.34 727.82 921.34 758.37 907.93 776.02 891.7 788.02 874.06 792.25 848.65 792.25 843 785.9 840.89 769.67 828.18 747.79 809.13 723.79 796.43 713.91 777.37 713.91 771.02 709.68 761.14 696.98 751.96 685.38 751.96 670.86 739.97 659.57 727.26 646.16 719.5 636.24 719.5 624.99 717.38 614.4 709.62 607.35 704.68 613.7 696.21 617.23 690.56 614.4 676.45 600.29 649.63 560.06 648.93 549.48 655.98 539.6 664.45 522.66 670.1 510.66 663.75 505.01 654.57 505.72 648.93 513.48 646.81 524.78 639.05 530.42 630.58 525.48 622.81 519.13 622.81 498.66 627.75 482.43 631.99 461.26 631.99 418.21 627.75 398.45 811.95 389.27'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='3'
				className={`polygon ${selectedZone === 'FL_ZS' ? 'selected' : ''}`}
				onClick={() => handleZoneClick('FL_ZS')}
			/>
			<polygon
				id='FL_ZN'
				points='811.95 389.27 827.48 391.39 825.36 381.51 797.13 351.16 773.14 317.99 751.26 280.59 734.32 247.42 720.21 212.84 703.97 177.55 703.97 170.15 659.47 170.15 653.87 180.38 658.81 203.66 656.69 216.37 648.22 219.19 636.22 200.14 591.06 202.25 380.04 218.49 361.69 190.26 121.74 214.25 110.45 224.13 110.25 235.42 133.14 256.93 133.74 274.94 137.97 277.06 140.79 291.88 189.49 276.36 229.01 274.24 267.83 275.65 293.94 284.82 311.58 295.41 334.87 312.35 353.93 336.34 368.04 334.93 390.63 327.87 411.8 316.58 426.62 307.41 437.2 305.29 439.32 291.18 449.2 280.59 482.37 280.59 500.72 290.47 514.84 303.88 531.77 319.41 555.77 346.22 575.53 361.04 599.52 372.34 613.64 381.51 627.75 398.45 811.95 389.27'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='3'
				className={`polygon ${selectedZone === 'FL_ZN' ? 'selected' : ''}`}
				onClick={() => handleZoneClick('FL_ZN')}
			/>
			<rect
				x='773.63'
				y='548.88'
				width='59.85'
				height='43.33'
				fill='none'
				className='shape'
			/>
			<path
				d='M773.01,588.4l27.45-32.89-.03-.18h-19.24l.83-4.29h25.94l-.63,3.23-27.25,32.74.06.18h21.25l-.82,4.29h-28.12l.56-3.08Z'
				className='shape'
			/>
			<path
				d='M807.5,585.22c2.2,1.48,5.23,2.58,8.61,2.58,4.55,0,8.74-2.72,8.74-7.59,0-3.01-1.69-5.24-5.92-7.56-5.16-2.79-8.05-6.03-8.05-10.37,0-7.24,6.22-11.87,13.65-11.87,3.95,0,6.89,1.15,8.28,2.1l-1.77,4.07c-1.27-.76-3.8-1.93-7.02-1.9-4.99,0-8.01,3.29-8.02,6.61,0,3.28,2.05,5.15,6.28,7.5,4.98,2.67,7.71,5.86,7.71,10.82,0,6.99-5.49,12.5-14.59,12.5-4.04,0-8.04-1.32-9.73-2.81l1.8-4.07Z'
				className='shape'
			/>
			<rect
				x='606.06'
				y='264.79'
				width='73.15'
				height='43.33'
				fill='none'
				className='shape'
			/>
			<path
				d='M605.45,304.32l27.45-32.89-.03-.18h-19.24l.83-4.29h25.94l-.63,3.23-27.25,32.74.06.18h21.25l-.82,4.29h-28.12l.56-3.08Z'
				className='shape'
			/>
			<path
				d='M639.31,307.39l7.69-40.44h5.45l9.26,22.9c1.79,4.6,2.7,7.8,3.55,11.28l.13-.06c.22-3.63.64-6.99,1.69-12.66l4.08-21.45h4.71l-7.69,40.44h-4.92l-9.22-22.86c-1.97-5-2.87-7.84-3.75-11.67l-.18.06c-.45,3.78-1.09,7.82-2.12,13.32l-3.99,21.14h-4.69Z'
				className='shape'
			/>
			<polygon
				points='662.3 488.68 662.4 493 666.95 493 662.47 495.68 662.58 500 659.7 497.33 655.22 500 657.92 495.68 655.05 493 659.59 493 662.3 488.68'
				className='shape'
			/>
			<rect x='664.09' y='470.81' width='78.28' height='20' fill='none' className='shape' />
			<path
				d='M670.38,473.4h-4.72l.34-1.73h11.46l-.34,1.73h-4.75l-2.74,14.45h-1.99l2.74-14.45Z'
				className='shape'
			/>
			<path
				d='M684.44,487.85c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.84,0-4.04,2.97-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM685.74,477.73c-.28-.09-.71-.17-1.38-.17-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M691.75,487.85l1.54-8.23c.25-1.29.41-2.42.54-3.38h1.75l-.31,2.18h.06c1.09-1.62,2.55-2.44,4.09-2.44,1.77,0,2.63,1.12,2.71,2.59,1.04-1.68,2.52-2.56,4.26-2.59,1.34,0,2.82.86,2.82,3.04,0,.54-.07,1.32-.19,1.97l-1.3,6.85h-1.94l1.25-6.69c.08-.45.17-1.03.17-1.52,0-1.23-.46-2.02-1.75-2.02-1.45,0-3.17,1.67-3.65,4.27l-1.11,5.95h-1.94l1.3-6.81c.1-.52.16-.96.16-1.42,0-.98-.27-1.99-1.74-1.99s-3.26,1.92-3.71,4.38l-1.07,5.83h-1.95Z'
				className='shape'
			/>
			<path
				d='M712.52,492.6l2.32-12.25c.26-1.4.5-2.94.65-4.11h1.82l-.33,2.19h.05c1.05-1.53,2.58-2.45,4.18-2.45,2.52,0,3.58,2.07,3.58,4.19,0,4.09-2.93,7.94-6.8,7.94-1.23,0-2.05-.27-2.5-.52h-.05l-.94,5.01h-1.98ZM715.78,485.9c.51.4,1.27.64,2.22.64,2.57,0,4.71-3.19,4.71-6.22,0-1.22-.54-2.69-2.22-2.69-1.57,0-3.51,1.78-4.12,5.03l-.59,3.24Z'
				className='shape'
			/>
			<path
				d='M736.28,487.85c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.84,0-4.04,2.97-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM737.58,477.73c-.28-.09-.71-.17-1.38-.17-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<polygon
				points='803.85 368.44 803.96 372.77 808.51 372.77 804.03 375.44 804.13 379.76 801.26 377.09 796.78 379.76 799.48 375.44 796.6 372.77 801.15 372.77 803.85 368.44'
				className='shape'
			/>
			<rect x='618.49' y='350.57' width='176.96' height='20' fill='none' className='shape' />
			<path
				d='M622.27,351.65c1.24-.22,2.6-.32,4.02-.32,2.7,0,4.76.77,5.95,2.15.87.9,1.51,2.35,1.52,4.39,0,2.93-1.17,5.83-3.25,7.6-1.87,1.57-4.23,2.25-7.33,2.25-1.41,0-2.87-.08-3.92-.2l3.01-15.87ZM621.55,365.96c.73.1,1.49.11,2.09.11,2.57,0,4.44-.76,5.79-2.15,1.46-1.49,2.21-3.69,2.21-5.97,0-2.86-1.4-5-5.43-5-.72,0-1.63.04-2.21.17l-2.44,12.84Z'
				className='shape'
			/>
			<path
				d='M645.06,367.61c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.83,0-4.04,2.97-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.1-.49,5.38h-1.86ZM646.35,357.49c-.28-.09-.71-.17-1.38-.17-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M654.82,356l1.15,6.24c.26,1.34.41,2.19.53,3.06h.06c.3-.74.65-1.56,1.23-2.84l2.97-6.46h2.11l-4.36,8.82c-1.25,2.52-2.42,4.55-4,6.11-1.3,1.31-2.71,1.86-3.38,2l-.49-1.71c.5-.17,1.34-.5,2.13-1.12.79-.61,1.62-1.54,2.24-2.68.1-.19.09-.33.06-.53l-2.33-10.9h2.07Z'
				className='shape'
			/>
			<path
				d='M670.52,352.88l-.6,3.12h2.77l-.31,1.56h-2.78l-1.07,5.64c-.13.65-.23,1.25-.23,1.85,0,.69.33,1.12,1.1,1.12.36,0,.68-.03.94-.09l-.1,1.57c-.35.14-.96.21-1.54.21-1.75,0-2.44-1.06-2.44-2.25,0-.68.08-1.34.25-2.18l1.13-5.88h-1.66l.3-1.56h1.67l.49-2.62,2.07-.5Z'
				className='shape'
			/>
			<path
				d='M686.3,360.57c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.16-4.53-4.77,0-3.83,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM677.37,363.03c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.74,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<path
				d='M690.11,367.61l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.16-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M713.05,367.61c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.5,3.26-2.06,0-3.34-1.63-3.34-3.83,0-4.04,2.98-8.3,8.03-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.1-.49,5.38h-1.86ZM714.34,357.49c-.28-.09-.71-.17-1.38-.17-3,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M730.19,351.66c.99-.2,2.16-.33,3.47-.33,1.67,0,2.87.34,3.73,1.11.75.61,1.16,1.47,1.16,2.52,0,2.04-1.65,3.56-3.48,4.04v.06c1.46.43,2.67,1.64,2.65,3.59,0,1.66-.88,2.96-1.94,3.75-1.28.96-3.07,1.33-5.24,1.33-1.39,0-2.6-.08-3.35-.23l2.99-15.83ZM729.42,366c.5.08,1.09.11,1.64.11,2.36.01,4.57-.97,4.57-3.56,0-1.9-1.6-2.73-3.42-2.73h-1.62l-1.17,6.19ZM730.91,358.3h1.48c2.32,0,4.11-1.2,4.11-3.17,0-1.56-1.18-2.22-2.94-2.22-.73,0-1.34.05-1.65.15l-1,5.25Z'
				className='shape'
			/>
			<path
				d='M750.42,366.94c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.24,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.8l.29,1.48ZM748.22,357.29c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.76-1.48Z'
				className='shape'
			/>
			<path
				d='M763.04,367.61c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.5,3.26-2.06,0-3.34-1.63-3.34-3.83,0-4.04,2.98-8.3,8.03-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.1-.49,5.38h-1.86ZM764.33,357.49c-.28-.09-.71-.17-1.38-.17-3,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M778.28,367.15c-.59.29-1.79.71-3.37.71-2.99,0-4.46-2.02-4.46-4.49,0-3.96,2.95-7.63,7.12-7.63,1.08,0,2.06.32,2.41.53l-.57,1.58c-.46-.22-1.1-.44-1.97-.44-3.01,0-4.92,2.97-4.92,5.71,0,1.89.99,3.1,2.89,3.1,1.18,0,2.09-.36,2.68-.65l.19,1.57Z'
				className='shape'
			/>
			<path
				d='M782.87,367.61l3.24-17.04h1.99l-1.45,7.48h.05c1-1.41,2.4-2.31,4.15-2.31,1.32,0,2.89.8,2.89,3.11,0,.62-.08,1.38-.19,1.96l-1.29,6.8h-1.99l1.27-6.71c.08-.42.16-.96.16-1.6,0-1.07-.51-1.91-1.8-1.91-1.54,0-3.47,1.8-3.95,4.4l-1.08,5.81h-1.99Z'
				className='shape'
			/>
			<polygon
				points='693.56 201.57 693.66 205.89 698.21 205.89 693.73 208.56 693.84 212.89 690.96 210.22 686.48 212.89 689.18 208.56 686.31 205.89 690.85 205.89 693.56 201.57'
				className='shape'
			/>
			<rect x='695.35' y='183.7' width='146.12' height='20' fill='none' className='shape' />
			<path
				d='M695.04,198.88c.53.22,1.18.35,2.04.35,1.7,0,2.77-.9,3.31-3.76l2.07-10.91h1.99l-2.11,11.13c-.71,3.79-2.29,5.31-5.32,5.31-.98,0-1.99-.21-2.4-.42l.43-1.7Z'
				className='shape'
			/>
			<path
				d='M714.94,200.74c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.5,3.26-2.06,0-3.34-1.63-3.34-3.84,0-4.04,2.98-8.3,8.03-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM716.23,190.61c-.28-.09-.71-.16-1.38-.16-3,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M730.18,200.28c-.59.29-1.79.71-3.37.71-2.99,0-4.46-2.03-4.46-4.49,0-3.96,2.95-7.63,7.12-7.63,1.08,0,2.06.32,2.41.53l-.57,1.58c-.46-.22-1.1-.44-1.97-.44-3.01,0-4.92,2.97-4.92,5.71,0,1.89.99,3.11,2.89,3.11,1.18,0,2.09-.36,2.68-.65l.19,1.57Z'
				className='shape'
			/>
			<path
				d='M734.77,200.74l3.24-17.04h1.98l-2.04,10.68h.05c.35-.41.78-.85,1.09-1.17l4.09-4.08h2.46l-5.06,4.76,3.46,6.84h-2.19l-2.79-5.73-1.47,1.31-.83,4.42h-1.98Z'
				className='shape'
			/>
			<path
				d='M748.23,198.72c.55.33,1.54.72,2.5.72,1.34,0,2.21-.87,2.21-1.9,0-.91-.41-1.47-1.61-2.14-1.34-.74-2.1-1.77-2.1-2.96,0-2.03,1.76-3.58,4.21-3.58,1.05,0,1.98.28,2.42.58l-.56,1.5c-.4-.23-1.13-.53-2-.53-1.21,0-2.07.76-2.07,1.74,0,.85.56,1.37,1.59,1.96,1.29.73,2.17,1.74,2.17,3.05,0,2.44-1.98,3.83-4.43,3.83-1.25,0-2.36-.39-2.89-.8l.57-1.47Z'
				className='shape'
			/>
			<path
				d='M770.65,193.69c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.16-4.53-4.77,0-3.83,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM761.72,196.15c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.73,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<path
				d='M774.46,200.74l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.17-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M792.14,189.13l1,6.61c.18,1.32.32,2.21.37,2.85h.07c.25-.62.57-1.38,1.24-2.71l3.54-6.76h2.18l-6.46,11.61h-1.96l-2.01-11.61h2.03Z'
				className='shape'
			/>
			<path
				d='M802.9,200.74l2.22-11.61h1.99l-2.22,11.61h-1.99ZM805.49,185.89c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.03.79-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path d='M810.83,200.74l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path d='M818.75,200.74l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path
				d='M835.03,200.07c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.43,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM832.83,190.41c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.95-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<polygon
				points='432.45 237.47 432.56 241.79 437.1 241.79 432.62 244.46 432.73 248.78 429.86 246.11 425.38 248.78 428.08 244.46 425.2 241.79 429.75 241.79 432.45 237.47'
				className='shape'
			/>
			<rect x='434.25' y='219.59' width='137.42' height='20' fill='none' className='shape' />
			<path
				d='M440.54,222.19h-4.72l.34-1.73h11.46l-.34,1.73h-4.75l-2.74,14.45h-1.99l2.74-14.45Z'
				className='shape'
			/>
			<path
				d='M454.6,236.63c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.84,0-4.04,2.97-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM455.89,226.51c-.28-.09-.71-.17-1.38-.17-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path d='M461.86,236.63l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path d='M469.78,236.63l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path
				d='M485.39,236.63c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.84,0-4.04,2.97-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM486.68,226.51c-.28-.09-.71-.17-1.38-.17-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M492.65,236.63l3.24-17.04h1.99l-1.45,7.48h.05c1-1.41,2.4-2.31,4.15-2.31,1.32,0,2.89.8,2.89,3.11,0,.62-.08,1.38-.19,1.96l-1.29,6.8h-1.99l1.27-6.71c.08-.42.16-.96.16-1.6,0-1.07-.51-1.91-1.8-1.91-1.54,0-3.47,1.8-3.95,4.4l-1.08,5.82h-1.99Z'
				className='shape'
			/>
			<path
				d='M515.58,236.63c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.5,3.26-2.06,0-3.34-1.63-3.34-3.84,0-4.04,2.98-8.3,8.03-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM516.87,226.51c-.28-.09-.71-.17-1.38-.17-3,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M522.98,234.62c.55.33,1.54.72,2.5.72,1.34,0,2.21-.87,2.21-1.9,0-.91-.41-1.47-1.61-2.14-1.34-.74-2.1-1.77-2.1-2.96,0-2.03,1.76-3.58,4.21-3.58,1.05,0,1.98.28,2.42.58l-.56,1.5c-.4-.23-1.13-.53-2-.53-1.21,0-2.07.76-2.07,1.74,0,.85.56,1.37,1.6,1.95,1.29.73,2.17,1.75,2.17,3.05,0,2.44-1.98,3.83-4.43,3.83-1.25,0-2.36-.39-2.89-.8l.57-1.47Z'
				className='shape'
			/>
			<path
				d='M534.36,234.62c.55.33,1.54.72,2.5.72,1.34,0,2.21-.87,2.21-1.9,0-.91-.41-1.47-1.61-2.14-1.34-.74-2.1-1.77-2.1-2.96,0-2.03,1.76-3.58,4.21-3.58,1.05,0,1.98.28,2.42.58l-.56,1.5c-.4-.23-1.13-.53-2-.53-1.21,0-2.07.76-2.07,1.74,0,.85.56,1.37,1.6,1.95,1.29.73,2.17,1.75,2.17,3.05,0,2.44-1.98,3.83-4.43,3.83-1.25,0-2.36-.39-2.89-.8l.57-1.47Z'
				className='shape'
			/>
			<path
				d='M554.01,235.97c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.24,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM551.81,226.31c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.76-1.48Z'
				className='shape'
			/>
			<path
				d='M567.33,235.97c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.43,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM565.13,226.31c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.96-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<polygon
				points='749.61 438.82 749.72 443.14 754.27 443.14 749.79 445.81 749.9 450.14 747.02 447.46 742.54 450.14 745.24 445.81 742.37 443.14 746.91 443.14 749.61 438.82'
				className='shape'
			/>
			<rect x='652.13' y='419.98' width='95.6' height='20' fill='none' className='shape' />
			<path
				d='M667.91,427.21c0,2.8-1.03,5.9-2.95,7.81-1.43,1.42-3.31,2.26-5.54,2.26-4.18,0-6.13-3.15-6.13-6.58,0-2.84,1.11-6,3.08-7.93,1.39-1.35,3.39-2.19,5.43-2.19,4.35,0,6.12,3.17,6.12,6.63ZM657.84,423.88c-1.55,1.56-2.46,4.4-2.46,6.66,0,2.63,1.17,5.06,4.33,5.06,1.38,0,2.69-.6,3.69-1.62,1.53-1.53,2.41-4.44,2.41-6.69s-.75-5.04-4.29-5.04c-1.44,0-2.7.63-3.7,1.62Z'
				className='shape'
			/>
			<path
				d='M671.41,437.02l1.42-7.48c.28-1.51.46-3.05.59-4.13h1.75c-.09.81-.19,1.62-.32,2.52h.07c.76-1.59,2-2.79,3.56-2.79.18,0,.41.01.57.04l-.39,1.96c-.14-.03-.32-.04-.54-.04-1.72,0-3.26,2.09-3.76,4.78l-.96,5.12h-1.99Z'
				className='shape'
			/>
			<path d='M681.45,437.02l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path
				d='M697.06,437.02c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.5,3.26-2.06,0-3.34-1.63-3.34-3.83,0-4.04,2.98-8.3,8.03-8.3,1.11,0,2.33.19,3.13.44l-1.19,6.05c-.38,2.02-.54,4.1-.49,5.38h-1.86ZM698.35,426.9c-.28-.09-.71-.17-1.38-.17-3,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M704.37,437.02l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.93.79,2.93,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.16-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M731.95,419.98l-2.55,13.36c-.22,1.2-.42,2.56-.49,3.68h-1.82l.31-2.3h-.05c-1.06,1.65-2.52,2.56-4.19,2.56-2.24,0-3.47-1.84-3.47-4.22,0-4.13,3.07-7.91,7.18-7.91.73,0,1.55.16,2.05.4l1.04-5.57h1.98ZM728.61,427.23c-.4-.27-1.07-.49-1.9-.49-2.79,0-4.95,2.97-4.95,6.05,0,1.41.48,2.86,2.19,2.86,1.53,0,3.38-1.75,3.88-4.36l.78-4.06Z'
				className='shape'
			/>
			<path
				d='M745.77,429.98c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.16-4.53-4.77,0-3.83,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM736.84,432.44c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.74,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<polygon
				points='919.93 683.39 920.04 687.71 924.58 687.71 920.1 690.38 920.21 694.7 917.34 692.03 912.86 694.7 915.56 690.38 912.68 687.71 917.23 687.71 919.93 683.39'
				className='shape'
			/>
			<rect x='841.47' y='665.51' width='71.78' height='20' fill='none' className='shape' />
			<path
				d='M855.77,682.55l1.16-8.74c.21-1.54.57-3.91.88-5.47h-.08c-.75,1.63-1.65,3.56-2.53,5.21l-4.81,8.9h-1.52l-1.2-8.71c-.25-1.86-.41-3.74-.52-5.4h-.05c-.34,1.5-.85,3.94-1.23,5.48l-2.2,8.73h-1.87l4.19-16.18h2.54l1.28,9.28c.16,1.38.35,2.85.39,4.06h.07c.49-1.2,1.18-2.65,1.88-4l5.01-9.33h2.6l-2.05,16.18h-1.94Z'
				className='shape'
			/>
			<path
				d='M863.44,682.55l2.22-11.61h1.99l-2.22,11.61h-1.99ZM866.03,667.7c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.78-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path
				d='M879.06,682.55c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.83,0-4.04,2.97-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.1-.49,5.38h-1.86ZM880.35,672.43c-.28-.09-.71-.17-1.38-.17-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M886.36,682.55l1.54-8.23c.25-1.29.41-2.42.54-3.38h1.76l-.31,2.18h.05c1.09-1.62,2.55-2.44,4.09-2.44,1.77,0,2.63,1.12,2.71,2.59,1.04-1.68,2.52-2.56,4.27-2.59,1.34,0,2.82.86,2.82,3.04,0,.54-.07,1.32-.19,1.97l-1.29,6.85h-1.95l1.25-6.69c.08-.45.17-1.04.17-1.52,0-1.23-.47-2.02-1.75-2.02-1.45,0-3.17,1.67-3.65,4.27l-1.11,5.95h-1.94l1.3-6.81c.1-.52.16-.96.16-1.42,0-.98-.27-1.99-1.74-1.99s-3.26,1.92-3.71,4.38l-1.07,5.83h-1.94Z'
				className='shape'
			/>
			<path
				d='M908.18,682.55l2.22-11.61h1.99l-2.22,11.61h-1.99ZM910.76,667.7c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.78-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<polygon
				points='159.7 268.07 159.81 272.39 164.36 272.39 159.88 275.07 159.98 279.39 157.11 276.72 152.63 279.39 155.33 275.07 152.45 272.39 157 272.39 159.7 268.07'
				className='shape'
			/>
			<rect x='161.5' y='250.2' width='121.38' height='20' fill='none' className='shape' />
			<path
				d='M165.28,251.3c.91-.21,2.2-.35,3.5-.35,1.56,0,3.06.38,3.96,1.25.76.71,1.17,1.65,1.17,2.93,0,1.8-.88,3.33-1.94,4.21-1.25,1.05-3.08,1.55-4.9,1.55-.61,0-1.14-.04-1.65-.13l-1.23,6.48h-1.96l3.04-15.94ZM165.75,259.08c.57.12,1.02.16,1.61.16,2.73,0,4.56-1.7,4.56-3.97,0-1.93-1.38-2.69-3.22-2.69-.79,0-1.39.07-1.74.17l-1.21,6.33Z'
				className='shape'
			/>
			<path
				d='M184.69,266.57c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.24,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM182.48,256.91c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.95-.73-1.48-1.76-1.48Z'
				className='shape'
			/>
			<path
				d='M189.61,267.24l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.93.79,2.93,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.17-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M204.95,265.22c.55.33,1.54.72,2.5.72,1.34,0,2.21-.87,2.21-1.9,0-.91-.41-1.47-1.61-2.14-1.34-.74-2.1-1.77-2.1-2.96,0-2.03,1.76-3.58,4.21-3.58,1.05,0,1.98.28,2.42.58l-.56,1.5c-.4-.23-1.13-.53-2-.53-1.21,0-2.07.76-2.07,1.74,0,.85.56,1.37,1.6,1.96,1.29.73,2.17,1.74,2.17,3.05,0,2.44-1.98,3.83-4.43,3.83-1.25,0-2.36-.39-2.89-.8l.57-1.47Z'
				className='shape'
			/>
			<path
				d='M223.92,267.24c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.5,3.26-2.06,0-3.34-1.63-3.34-3.84,0-4.04,2.98-8.3,8.03-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM225.21,257.12c-.28-.09-.71-.16-1.38-.16-3,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M239.16,266.78c-.59.29-1.79.71-3.37.71-2.99,0-4.46-2.03-4.46-4.49,0-3.96,2.95-7.63,7.12-7.63,1.08,0,2.06.32,2.41.53l-.57,1.58c-.46-.22-1.1-.44-1.97-.44-3.01,0-4.92,2.97-4.92,5.71,0,1.89.99,3.11,2.89,3.11,1.18,0,2.09-.36,2.68-.65l.19,1.57Z'
				className='shape'
			/>
			<path
				d='M254.68,260.19c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.16-4.53-4.77,0-3.83,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM245.75,262.66c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.73,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<path d='M258.49,267.24l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path
				d='M274.11,267.24c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.84,0-4.04,2.97-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM275.4,257.12c-.28-.09-.71-.16-1.38-.16-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
		</svg>
	);
};

FloridaMap.propTypes = {
	onZoneClick: PropTypes.func.isRequired,
	selectedZone: PropTypes.string,
};

export default FloridaMap;
